/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 2:45 PM
 */
// zoom configuration
export const ZOOM_API_KEY = "CBDC4YXbSASZClDtRGsK0g";
export const ZOOM_ROLE = 0;
export const ZOOM_LANG = "en-US";
